// extracted by mini-css-extract-plugin
export default {"sectionForm":"stack_sectionForm__P25l+","input":"stack_input__bMSn0","buttonReset":"stack_buttonReset__8BbiO","sectionResult":"stack_sectionResult__Geiiz"};